import { createAction, props } from "@ngrx/store";
import {Course} from '../models/course.model';
export const courseDetails = createAction(
    '[Course data] Retrieve courses data', props<{ courseData: Course[]}>()
)